import { SVGProps } from 'react';


export default function HomeArrow(props: Partial<SVGProps<any>>) {
  return (
<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <rect width="72" height="72" rx="36" fill="black" fillOpacity="0.37"/>
  <path d="M36 45.3913L37.6552 43.7361L31.1048 37.1739H45.3913V34.8261H31.1048L37.667 28.2756L36 26.6087L26.6087 36L36 45.3913Z" fill="white"/>
</svg>
  )
}